module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.placeholder,
      "options": _vm.categories,
      "disabled": _vm.disabled,
      "show-all-levels": _vm.showLevels,
      "allow-create": _vm.create,
      "size": _vm.size
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4531c9f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectStructure.vue
// module id = 1536
// module chunks = 0